import React, { useState } from "react";
import { products } from "./data/drawerFittingData";
import "../../App.css";
import { Helmet } from "react-helmet";
import banner from "../../assets/about-banner.webp";

const DrawerFitting = () => {

  const [selectedItem, setSelectedItem] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [activeTab, setActiveTab] = useState("desc");
const [previewImage, setPreviewImage] = useState(null);
  // ✅ YouTube Embed Fix
  const getEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("shorts")) {
      const id = url.split("/shorts/")[1]?.split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("watch?v=")) {
      const id = url.split("v=")[1]?.split("&")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    return url;
  };

  // ✅ Watch URL Fix
  const getYouTubeWatchUrl = (url) => {
    if (!url) return "#";

    if (url.includes("shorts")) {
      const id = url.split("/shorts/")[1]?.split("?")[0];
      return `https://www.youtube.com/watch?v=${id}`;
    }

    if (url.includes("embed")) {
      const id = url.split("/embed/")[1];
      return `https://www.youtube.com/watch?v=${id}`;
    }

    return url;
  };

  const filteredProducts = products.filter(
    (product) => product.category === "drawer fitting"
  );

  return (
    <div className="product-container">

      <Helmet>
        <link
    rel="canonical"
    href="https://slimlinehardwarefittings.com/drawer-fitting"
  />
        <title>Drawer Fittings | Kitchen Hardware Accessories</title>
        <meta
          name="description"
          content="Complete drawer fitting solutions for modular kitchen hardware."
        />
      </Helmet>

      {/* ===== BANNER ===== */}
      <div className="hinge-banners">
        <img src={banner} alt="Banner"  loading="lazy"/>
        <h2 className="banner-text">Products</h2>
      </div>

      <h2 className="page-title" style={{ textAlign: "center" }}>
        DRAWER FITTING
      </h2>

      {!selectedItem ? (

        <div className="product-grid">
          {filteredProducts.map((item) => (
            <div
              className="product-card"
              key={item.code}
              onClick={() => {
                setSelectedItem(item);
                setMainImage(item.mainImage);
                setActiveFAQ(null);
                setActiveTab("desc");
              }}
            >
            <img
  src={item.mainImage}
  alt={item.name}
  loading="lazy"
  onClick={(e) => {
    e.stopPropagation();
    setPreviewImage(item.mainImage);
  }}
  className="zoomable-image"
/>
              <h4>{item.name}</h4>
            </div>
          ))}
        </div>

      ) : (

        <>
          {/* BACK */}
          <button
            className="back-btn"
            onClick={() => {
              setSelectedItem(null);
              setMainImage("");
              setActiveFAQ(null);
            }}
          >
            ← Back
          </button>

          <div className="hinge-details">

            {/* LEFT */}
            <div className="left-box">

              <div className="hinge-image">
                          <div className="hinge-image">
              <img
                src={mainImage}
            alt={selectedItem.name}
                className="zoomable-image"
                onClick={() => setPreviewImage(mainImage)}
              />
</div>
              </div>

              <div className="hinge-thumbnails">
                {selectedItem.thumbnails?.map((img, i) => (
                 <img
  key={i}
  src={img}
  alt=""
  loading="lazy"
  onClick={() => setMainImage(img)}
  onDoubleClick={() => setPreviewImage(img)}
/>
                ))}
              </div>

              {/* VIDEO */}
              {selectedItem.video && (
                <div className="product-video">
                  <iframe
                    width="100%"
                    height="300"
                    src={getEmbedUrl(selectedItem.video)}
                    title="Product Video"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              )}

            </div>

            {/* RIGHT */}
            <div className="hinge-info">

              <h2>{selectedItem.name}</h2>

              {/* PRICE */}
              <div className="price-box">
                <span className="price">{selectedItem.price}</span>
                <span className="old-price">{selectedItem.oldPrice}</span>
              </div>

              {/* META */}
              <div className="product-meta">
                <p><strong>SKU:</strong> {selectedItem.sku}</p>
                <p><strong>Status:</strong> {selectedItem.stock}</p>
              </div>

              {/* BUTTONS */}
              <div className="btns">

                {selectedItem.catalogue && (
                  <a href={selectedItem.catalogue} download>
                    📥 Download Catalogue
                  </a>
                )}

                {selectedItem.inquiry && (
                  <a href={selectedItem.inquiry} target="_blank" rel="noreferrer">
                    💬 Inquiry
                  </a>
                )}

                {selectedItem.video && (
                  <a
                    href={getYouTubeWatchUrl(selectedItem.video)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    ▶ Watch Video
                  </a>
                )}

              </div>

              {/* TABS */}
              <div className="tabs">
                <button onClick={() => setActiveTab("desc")}>Description</button>
                <button onClick={() => setActiveTab("info")}>Additional Info</button>
              </div>

              {/* DESCRIPTION */}
              {activeTab === "desc" && (
                <>
                  <p>{selectedItem.short}</p>
                  <ul>
                    {selectedItem.features?.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </>
              )}

              {/* 🔥 UPDATED ADDITIONAL INFO (TABLE STYLE) */}
              {activeTab === "info" && (
                <div className="info-table">

                  {selectedItem.specifications?.length ? (
                    <table>
                      <tbody>
                        {selectedItem.specifications.map((s, i) => (
                          <tr key={i}>
                            <td><strong>{s.label}</strong></td>
                            <td>{s.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No additional info</p>
                  )}

                </div>
              )}

            </div>

          </div>

          {/* SPEC TABLE */}
          {selectedItem.specTable?.length > 0 && (
            <div className="spec-section">

              <h2>Specifications</h2>

              <table className="spec-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Code</th>
                    <th>Size</th>
                    <th>Finish</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedItem.specTable.map((item, i) => (
                    <tr key={i}>
                      <td>{item.item}</td>
                      <td>{item.code}</td>
                      <td>{item.size}</td>
                      <td>{item.finish}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          )}

          {/* FAQ */}
          {selectedItem.faq && (
            <div className="faq-section">

              <h2>Frequently Asked Questions</h2>

              {selectedItem.faq.map((item, index) => (
                <div key={index} className="faq-box">

                  <div
                    className={`faq-question ${activeFAQ === index ? "active" : ""}`}
                    onClick={() =>
                      setActiveFAQ(activeFAQ === index ? null : index)
                    }
                  >
                    <h4>{item.question}</h4>
                    <span>{activeFAQ === index ? "−" : "+"}</span>
                  </div>

                  {activeFAQ === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}

                </div>
              ))}

            </div>
          )}

{previewImage && (
  <div
    className="image-preview-modal"
    onClick={() => setPreviewImage(null)}
  >
    <span
      className="image-preview-close"
      onClick={() => setPreviewImage(null)}
    >
      ✕
    </span>

    <img
      src={previewImage}
      alt="Preview"
      className="image-preview-full"
      onClick={(e) => e.stopPropagation()}
    />
  </div>
)}
        </>
      )}
    </div>
  );
};

export default DrawerFitting;